import React, { useState, useEffect } from 'react';


export const ErrorDiv = ({errors,...props})=>{

    const [error, setError] = useState(null);

    useEffect(()=>{
        const recursivelyBreakDownObjects = (obj, parentKey = '') => {
            let error = [];

            if (typeof obj === 'object' && !Array.isArray(obj) && obj !== null) {
                Object.keys(obj).forEach(key => {
                    const value = obj[key];
                    const currentKey = parentKey ? `${parentKey} - ${key}` : key;


                    if (typeof value === 'string') {
                        error.push(`${currentKey}: ${value}`);
                    } else if (Array.isArray(value)) {
                        if (value.length > 0) {
                            value.forEach((item) => {
                                if (typeof item === 'string') {
                                    error.push(`${currentKey}: ${item}`);
                                } else if (typeof item === 'object' && item !== null) {
                                    const nestedErrors = recursivelyBreakDownObjects(item, `${currentKey}`);
                                    error = error.concat(nestedErrors);
                                } else {
                                    error.push(`${currentKey}: ${item}`);
                                }
                            });
                        }
                    } else if (typeof value === 'object' && value !== null) {
                        const nestedErrors = recursivelyBreakDownObjects(value, currentKey);
                        error = error.concat(nestedErrors);
                    } else {
                        error.push(`${currentKey}: ${value}`);
                    }
                });
            } else if (Array.isArray(obj)) {
                obj.forEach((item) => {
                    if (typeof item === 'string') {
                        error.push(item);
                    } else if (typeof item === 'object' && item !== null) {
                        const nestedErrors = recursivelyBreakDownObjects(item, parentKey);
                        error = error.concat(nestedErrors);
                    } else {
                        error.push(String(item));
                    }
                });
            } else {
                error.push(parentKey ? `${parentKey}: ${obj}` : String(obj));
            }


            return error;
        };
   
        if(Array.isArray(errors) && errors.length === 0) setError(null);
        else if (errors) {
            let newErrors = (recursivelyBreakDownObjects(errors));
            setError(newErrors);
        }

    },[errors])

    return(
        <div>
            {error ?
                <p style={{textAlign: "center", marginTop: "1rem"}}>
                    {error?.map((errorMsg, i)=>(
                        <span key={`error-${i}`} className="error-text">
                            {errorMsg}
                            <br />
                        </span>
                    ))}
                </p>
                :
                null
            }
        </div>
    )
}


export default ErrorDiv;